import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractCustomerComponent } from '@df/account/v2/abstract-customer.component';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { CustomerOptionLabelPipe } from '@df/ui/common/customer-option-label.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CustomerNamePipe } from '../../ui/account/customer-name.pipe';
import { Section2Component } from '../../ui/display/section2/section2.component';
import { AccountBackComponent } from '../back/account-back.component';
@Component({
    selector: 'account-edit',
    templateUrl: './account-edit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [GridModule, Section2Component, CustomerNamePipe, AccountBackComponent, TranslationModule, CustomerOptionLabelPipe]
})
export class AccountEditComponent extends AbstractCustomerComponent {
}
